import axios from "axios";

export const FY_MIN = 2010;

export const currentFYStart = () => {
  const d = new Date();
  return d.getMonth() + 1 >= 4 ? d.getFullYear() : d.getFullYear() - 1;
};

export const fyLabel = (y) => `${y}-${String((y + 1) % 100).padStart(2, "0")}`;

const KEY = "gst.fyRange";
let _range = null;
try {
  const raw = localStorage.getItem(KEY);
  if (raw) {
    const p = JSON.parse(raw);
    if (p && typeof p.from_year === "number" && typeof p.to_year === "number") _range = p;
  }
} catch {}
if (!_range) _range = { from_year: currentFYStart(), to_year: currentFYStart() };

export const getFYRange = () => _range;

export const setFYRangeLocal = (r) => {
  _range = { from_year: r.from_year, to_year: Math.max(r.from_year, r.to_year) };
  try { localStorage.setItem(KEY, JSON.stringify(_range)); } catch {}
};

export const hasStoredFYRange = () => {
  try { return !!localStorage.getItem(KEY); } catch { return false; }
};

export const fyRangeLabel = (r) =>
  r.from_year === r.to_year
    ? `FY ${fyLabel(r.from_year)}`
    : `FY ${fyLabel(r.from_year)} \u2192 ${fyLabel(r.to_year)}`;

// ---- Screen-scoped Date Filter (F2 single date / Alt+F2 range) ----
// The filter is tied to the screen (pathname) where it was set. Only that
// screen's data is filtered; navigating to any other screen shows normal
// (unfiltered) data and the filter is dropped automatically.
const DF_KEY = "gst.dateFilter";
let _dateFilter = null;
try {
  const raw = localStorage.getItem(DF_KEY);
  if (raw) {
    const p = JSON.parse(raw);
    if (p && p.from && p.to && p.path) _dateFilter = p;
  }
} catch {}

export const getDateFilter = () => {
  if (_dateFilter && _dateFilter.path !== window.location.pathname) return null;
  return _dateFilter;
};
export const setDateFilterLocal = (from, to) => {
  _dateFilter = { from, to, path: window.location.pathname };
  try { localStorage.setItem(DF_KEY, JSON.stringify(_dateFilter)); } catch {}
};
export const clearDateFilterLocal = () => {
  _dateFilter = null;
  try { localStorage.removeItem(DF_KEY); } catch {}
};

// Global interceptor — every API call carries the selected FY window
// (1 April of from_year → 31 March following to_year). The F2 date filter
// overrides it ONLY while the user is on the screen where it was set.
axios.interceptors.request.use((cfg) => {
  if (_dateFilter && _dateFilter.path === window.location.pathname) {
    cfg.headers["X-FY-From"] = _dateFilter.from;
    cfg.headers["X-FY-To"] = _dateFilter.to;
  } else if (_range) {
    cfg.headers["X-FY-From"] = `${_range.from_year}-04-01`;
    cfg.headers["X-FY-To"] = `${_range.to_year + 1}-03-31`;
  }
  return cfg;
});
